import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { TimeSeriesData, CHART_COLORS } from '../../../../types/dashboard-v4.types';
import { PanelHeading } from './PanelHeading';

interface SignalsTimeChartProps {
  data: TimeSeriesData[];
}

export const SignalsTimeChart: React.FC<SignalsTimeChartProps> = React.memo(({ data }) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm">
      <PanelHeading>
        Signals and cases over time
      </PanelHeading>
      
      <ResponsiveContainer width="100%" height={200}>
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
          <XAxis 
            dataKey="date" 
            stroke="#9CA3AF"
            fontSize={12}
            axisLine={false}
            tickLine={false}
          />
          <YAxis 
            stroke="#9CA3AF" 
            fontSize={12}
            axisLine={false}
            tickLine={false}
          />
          <Tooltip 
            contentStyle={{
              backgroundColor: 'white',
              border: '1px solid #E5E7EB',
              borderRadius: '8px',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
            }}
          />
          <Line
            type="monotone"
            dataKey="signals"
            stroke={CHART_COLORS.SECONDARY}
            strokeWidth={3}
            dot={{ fill: CHART_COLORS.SECONDARY, strokeWidth: 0, r: 4 }}
            activeDot={{ r: 6, fill: CHART_COLORS.SECONDARY }}
          />
          <Line
            type="monotone"
            dataKey="cases"
            stroke={CHART_COLORS.PURPLE}
            strokeWidth={3}
            dot={{ fill: CHART_COLORS.PURPLE, strokeWidth: 0, r: 4 }}
            activeDot={{ r: 6, fill: CHART_COLORS.PURPLE }}
          />
        </LineChart>
      </ResponsiveContainer>
      
      {/* Legend */}
      <div className="flex items-center justify-center gap-6 mt-4">
        <div className="flex items-center gap-2">
          <div 
            className="w-3 h-3 rounded-full"
            style={{ backgroundColor: CHART_COLORS.SECONDARY }}
          />
          <span className="text-sm text-gray-600">Signals</span>
        </div>
        <div className="flex items-center gap-2">
          <div 
            className="w-3 h-3 rounded-full"
            style={{ backgroundColor: CHART_COLORS.PURPLE }}
          />
          <span className="text-sm text-gray-600">Cases</span>
        </div>
      </div>
    </div>
  );
});